import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import type { RoutineItem } from "../types/api-types";
import ExportCsvButton from "../../shared/export/export-csv-button";
import type { CsvColumn } from "../../shared/export/csv-export";

const exportColumns: CsvColumn<RoutineItem>[] = [
  { header: "Description", value: (routine) => routine.description },
];

interface RoutinesTableProps {
  routines: RoutineItem[];
  onDelete: (id: number, description: string) => void;
}

const RoutinesTable = ({ routines, onDelete }: RoutinesTableProps) => {
  if (routines.length === 0) {
    return (
      <Box
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography variant="body2" color="text.secondary" textAlign="center">
          No routines configured
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer
      sx={{
        maxHeight: 300,
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow
            sx={{
              "& .MuiTableCell-root": {
                fontWeight: 600,
                color: "primary.main",
                bgcolor: "grey.50",
              },
            }}
          >
            <TableCell>Description</TableCell>
            <TableCell align="right">
              <ExportCsvButton
                rows={routines}
                columns={exportColumns}
                fileName="routines"
              />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {routines.map((routine) => (
            <TableRow
              key={routine.id}
              sx={{
                "&:hover": {
                  bgcolor: "action.hover",
                },
                "&:last-child td": {
                  borderBottom: 0,
                },
              }}
            >
              <TableCell sx={{ py: 1.5 }}>{routine.description}</TableCell>
              <TableCell align="right" sx={{ py: 1 }}>
                <IconButton
                  size="small"
                  onClick={() => onDelete(routine.id, routine.description)}
                  sx={{
                    color: "text.secondary",
                    "&:hover": {
                      color: "error.main",
                      bgcolor: "error.lighter",
                      transform: "scale(1.1)",
                    },
                    transition: "all 0.2s ease-in-out",
                  }}
                  aria-label="Delete routine"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RoutinesTable;
